<script setup lang="ts">
export interface CardCreditCardProps {
  card: IModelCreditCard;
  hasEdit?: boolean;
  hasDelete?: boolean;
  hasRadio?: boolean;
  hasRadioActive?: boolean;
  disabled?: boolean;
}

const { t } = useI18n();
const emit = defineEmits(["edit", "delete", "update:has-radio-active"]);
const props = withDefaults(defineProps<CardCreditCardProps>(), {});
const onEditClick = () => emit("edit");
const onDeleteClick = () => emit("delete");
const onRadioClick = (value: boolean) => emit("update:has-radio-active", value);
const cardNumber = props.card.cardNumber.replace("**** **** ****", "•••");
</script>

<template>
  <div class="CardCreditCard" data-test-id="credit-card" tabIndex="0">
    <div class="flex items-start">
      <base-radio v-if="props.hasRadio" name="card" :disabled="props.disabled" :model-value="props.hasRadioActive" @update:model-value="onRadioClick" />

      <div class="ml-2 mr-4">
        <icon-credit-card-type v-if="props.card.cardType" :type="props.card.cardType" />
      </div>
      <div>
        <div class="text-body-medium text-main mb-2">
          {{ cardNumber }}
        </div>
        <div class="text-caption-medium text-secondary">
          {{ t('pages.account_billing.card_expiry_date') }}: {{ props.card.cardExpiration }}
        </div>
      </div>
    </div>
    <div class="text-secondary">
      <BaseButton v-if="props.hasEdit" class="CardCreditCard__edit mx-4" type="icon" name="edit-card" :title="t('button.edit')" @click="onEditClick()">
        <IconEdit fill="currentColor" />
      </BaseButton>
      <BaseButton v-if="props.hasDelete" class="CardCreditCard__delete" type="icon" name="delete-card" :title="t('button.delete')" @click="onDeleteClick()">
        <IconDelete fill="var(--base-error-color)" />
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss">
.CardCreditCard {
  @apply flex justify-between items-start p-4 rounded-md;

  border: 1px solid var(--base-card-bgSecondaryColor);
  border-radius: var(--base-border-radius);

  .CardCreditCard__edit {
    @apply transition;

    &:hover {
      color: var(--base-success-color);
    }
  }
  .CardCreditCard__delete {
    @apply transition;

    &:hover {
      color: var(--base-error-color);
    }
  }
}
</style>
